import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const FIND_SALES_ORDER_REQUEST = NS + 'FIND_SALES_ORDER_REQUEST'
export const FIND_SALES_ORDER_SUCCESS = NS + 'FIND_SALES_ORDER_SUCCESS'
export const FIND_SALES_ORDER_ERROR = NS + 'FIND_SALES_ORDER_ERROR'


export const CHANGE_SALES_ORDER = NS + 'CHANGE_SALES_ORDER'

export const SAVE_SALES_ORDER_REQUEST = NS + 'SAVE_SALES_ORDER_REQUEST'
export const SAVE_SALES_ORDER_SUCCESS = NS + 'SAVE_SALES_ORDER_SUCCESS'
export const SAVE_SALES_ORDER_ERROR = NS + 'SAVE_SALES_ORDER_ERROR'


export const CHANGE_SALES_ORDER_CUSTOMER = NS + 'CHANGE_SALES_ORDER_CUSTOMER'
export const CHANGE_SALES_ORDER_CUSTOMER_CONTACT = NS + 'CHANGE_SALES_ORDER_CUSTOMER_CONTACT'

export const SAVE_SALES_ORDER_CUSTOMER_REQUEST = NS + 'SAVE_SALES_ORDER_CUSTOMER_REQUEST'
export const SAVE_SALES_ORDER_CUSTOMER_SUCCESS = NS + 'SAVE_SALES_ORDER_CUSTOMER_SUCCESS'
export const SAVE_SALES_ORDER_CUSTOMER_ERROR = NS + 'SAVE_SALES_ORDER_CUSTOMER_ERROR'

export const ADD_SHIPMENT = NS + 'ADD_SHIPMENT'

export const ADD_SENT_EMAIL = NS + 'ADD_SENT_EMAIL'

export const ADD_INVOICE = NS + 'ADD_INVOICE'

export const ADD_LOW_NPS_REASON = NS + 'ADD_LOW_NPS_REASON'

export const HYDRATE_SALESORDER_CUSTOMER_CONTACT = NS + 'HYDRATE_SALESORDER_CUSTOMER_CONTACT'




// WEBPACK FOOTER //
// ./src/modules/sales-order/state/detail/type.js